<template>
  <div class="">
    <Card class="">
      <template #title> Yeni Musteri </template>
      <template #content>

        <div class="grid">

          <div class="col-12">
            <Tabs value="0">
              <TabList>
                <Tab value="0">Genel Bilgiler</Tab>
                <Tab value="1">İletişim Bilgileri</Tab>
                <Tab value="2" disabled>Boş</Tab>
              </TabList>
              <TabPanels>
                <!-- GENEL BİLGİLER -->
                <TabPanel value="0">
                  <div class="formgrid grid ">
                    <div class="field col md:col-4">
                      <label for="Isim" class="font-bold block">İsim</label>
                      <InputText id="Isim" type="text" v-model="Isim" class="text-base text-color w-full"
                        :invalid="this.Valid.Isim" />
                    </div>
                    <div class="field col md:col-4"></div>
                    <div class="field col md:col-4">
                      <label for="Grup" class="font-bold block">Grup</label>
                      <Select id="Grup" v-model="pGrup" :options="GrupListesi" optionLabel="Ad"
                        optionValue="Grup_rowid" placeholder="Seçiniz..." checkmark filter
                        :highlightOnSelect="true" :invalid="this.Valid.pGrup" class="text-base text-color w-full" />
                    </div>
                    <div class="field col md:col-4">
                      <label for="CepTelefon" class="font-bold block">Cep Telefon</label>
                      <InputMask id="CepTelefon" v-model="CepTelefon" mask="(999) 999-9999" placeholder="(999) 999-9999"
                        :invalid="this.Valid.CepTelefon" fluid />
                    </div>
                    <div class="field col md:col-4">
                      <label for="EPosta" class="font-bold block">E-Posta</label>
                      <InputText id="EPosta" type="text" v-model="EPosta" class="text-base text-color w-full"
                        :invalid="this.Valid.EPosta" />
                    </div>
                    <div class="field col md:col-4">
                      <label for="WebAdres" class="font-bold block">Web Adres</label>
                      <InputText id="WebAdres" type="text" v-model="WebAdres" class="text-base text-color w-full"
                        :invalid="this.Valid.WebAdres" />
                    </div>
                    <div class="field col md:col-6">
                      <label for="Aciklama" class="font-bold block">Açıklama</label>
                      <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30" :invalid="this.Valid.Aciklama"
                        class="text-base text-color w-full" />
                    </div>
                    <div class="field col md:col-6">
                      <label for="IletisimAdres" class="font-bold block">Adres</label>
                        <Textarea id="IletisimAdres" v-model="IletisimAdres" rows="2" cols="30" :invalid="this.Valid.IletisimAdres"
                        class="text-base text-color w-full" />

                    </div>
                  </div>
                </TabPanel>
                <!-- İLETİŞİM BİLGİLERİ -->
                <TabPanel value="1">


                </TabPanel>
                <!-- BOŞ -->
                <TabPanel value="2">

                </TabPanel>
              </TabPanels>
            </Tabs>
          </div>

          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-12 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
  data() {
    return {
      IslemYapiliyor: false,

      GrupListesi: [],

      // Genel Bilgiler
      pGrup: 0,
      Aciklama: "",
      // İletişim Bilgileri
      Isim: "",
      IletisimAdres: "",
      CepTelefon: "",
      EPosta: "",
      WebAdres: "",

      //--------------
      // Validation Elements
      Valid: {
        pGrup: false,
        Aciklama: false,
        Isim: false,
        IletisimAdres: false,
        CepTelefon: false,
        EPosta: false,
        WebAdres: false,
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;

      let data = {
        pGrup: this.pGrup,
        Aciklama: this.Aciklama,
        Isim: this.Isim,
        IletisimAdres: this.IletisimAdres,
        CepTelefon: this.CepTelefon,
        EPosta: this.EPosta,
        WebAdres: this.WebAdres,
      };

      GlobalServis.GlobalServis("POST", "SetMusteri", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Musteri oluşturulmuştur",
            life: 3000,
          });
          this._ResetForm();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Musteri/MusteriListesi" });
      });
    },
    _GrupListesi() {
      GlobalServis.GlobalServis("GET", "GetGrup_Musteri", "").then((res) => {
        if (res.status == 200) {
          this.GrupListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });
     
    },
    _ResetForm() {
      this.pGrup = 0;
      this.Aciklama = "";
      this.Isim = "";
      this.IletisimAdres = "";
      this.CepTelefon = "";
      this.EPosta = "";
      this.WebAdres = "";
    },
    _FormCheck() {
      let Check = false;

      if (this.pGrup === 0) {
        this.Valid.pGrup = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Grup seçin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.pGrup = false; Check = false; }

      if (this.Isim === "") {
        this.Valid.Isim = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "İsim girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Isim = false; Check = false; }

      if (this.IletisimAdres === "") {
        this.Valid.IletisimAdres = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "İletişim adresi girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.IletisimAdres = false; Check = false; }

      if (this.CepTelefon === "") {
        this.Valid.CepTelefon = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Cep telefonu girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.CepTelefon = false; Check = false; }

      if (this.EPosta === "") {
        this.Valid.EPosta = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "E-Posta adresi girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.EPosta = false; Check = false; }

      return Check;
    },
  },
  mounted() {
    this._GrupListesi();
  },
  components: {
  },
};
</script>